import React, { Component } from 'react'
import { withFormik } from 'formik'
import TextInput from '../ui/inputs/TextInput'
import Submit from '../ui/inputs/Submit'

import { Link } from 'react-router-dom'
import * as Yup from '@app/helpers/yup'
import AnalyticsManager, { PageEventsTypes } from '@app/analytics/manager'
import { transliterate } from '@app/helpers/transliterateHelper'
import { platformPath } from '@app/components/ui/buttons/PlatformLink'
import _ from 'lodash'

const formikEnhancer = withFormik({
  validationSchema: () => {
    return Yup.object().shape({
      login: Yup
        .string()
        .label(I18n.t('auth.login'))
        .required(),

      password: Yup
        .string()
        .label(I18n.t('auth.password'))
        .required()
    })
  },

  mapPropsToValues: ({ user }) => ({
    login: user.login || '',
    password: user.password || ''
  }),

  handleSubmit: (payload, { props }) => {
    const { onSubmit } = props
    onSubmit(payload)
  },

  displayName: 'LoginForm'
});

class LoginForm extends Component {
  constructor(props) {
    super(props)
    this.transliterate = this.transliterate.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.submitting !== this.props.submitting) {
      this.props.setSubmitting(this.props.submitting)
    }
  }

  get isTranslaterationEnabled() {
    if (window.COUNTRY !== 'RU' || I18n.locale !== 'ru') { return false }

    const { values } = this.props
    if (!values.login || values.login.search(/^[\d]+$/) !== 0) { return false }

    return true
  }

  transliterate(e) {
    if (!this.isTranslaterationEnabled) { return true }

    const { values, setFieldValue } = this.props
    setFieldValue('password', transliterate(values.password), false)
  }

  render() {
    const {
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
      handleSubmit,
      handleReset,
      isSubmitting,
      submitCount,
      error,
      user,
      prefix
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <div className="w-flex-layout mt-gutter-m">
          <p>Start your journey here</p>
          <a className="btn btn--blue f--upper mb-gutter-s" href={platformPath('log-in')} onClick={() => {
            AnalyticsManager.emitPageEvent(PageEventsTypes.OlympLoginClick)
          }}>
            { I18n.t('auth.sign_in') }
          </a>
          <a className="btn btn--light-blue f--upper" href={platformPath('sign-up')} onClick={() => {
            AnalyticsManager.emitPageEvent(PageEventsTypes.OlympSignUpClick)
          }}>
            { I18n.t('auth.sign_up') }
          </a>
        </div>
      </form>
    )
  }
}

export default formikEnhancer(LoginForm)
